import React from 'react';

// ICONS
import { Check } from 'lucide-react';

const CheckboxInput = ({ 
  id, 
  name, 
  checked, 
  disabled,
  onChange, 
  label, 
  className = '' 
}) => {
  return (
    <label htmlFor={id} className={`flex items-center cursor-pointer relative ${className}`}>
        <input
            type="checkbox"
            id={id}
            name={name}
            checked={checked}
            onChange={onChange}
            className="peer hidden"
        />
        {/* Case « vide » */}
        <div
            className={`
                size-5 mr-2 rounded-md border-2 border-gray-300
                peer-checked:bg-orange peer-checked:border-orange
                transition-colors duration-200
                hover:border-orange hover:shadow-sm
                ${disabled ? 'opacity-50 cursor-not-allowed hover:border-gray-300 hover:shadow-none' : ''}
            `}
        />

        {/* Coche, maintenant sibling direct de l'input */}
        <Check
            className={`
                absolute left-1 top-1.5
                size-3
                text-blanc
                hidden peer-checked:block
                transition-opacity duration-200
                ${disabled ? 'opacity-50' : ''}
            `}
            strokeWidth={5}
        />
        <span className={`text-gray-700 dark:text-gray-200 ${disabled ? 'opacity-50' : ''}`}>
            {label}
        </span>
    </label>
  );
};

export default CheckboxInput; 